// import React from "react";
// import { Input } from "@windmill/react-ui";

// const InputName = ({
//   register,
//   trigger,
//   defaultValue,
//   required,
//   name,
//   label,
//   type,
//   placeholder,
//   pattern,
//   minLength,
//   maxLength,
//   value,
//   readOnly,
//   onChange,
// }) => {
//   const validation = {
//     required: required === false ? false : `${label} is required!`,
//     pattern: {
//       value: pattern,
//       message: `Invalid ${label}!`,
//     },
//     maxLength: {
//       value: maxLength,
//       message: `Maximum Length ${maxLength}!`,
//     },
//     minLength: {
//       value: minLength,
//       message: `Minimum Length ${minLength}!`,
//     },
//     validate: (value) => {
//       if (
//         typeof value === "string" &&
//         value.trim() === "" &&
//         required !== false
//       ) {
//         return `${label} is required!`;
//       }
//       return true;
//     },
//   };

//   const handleInput = (event) => {
//     // Allow only letters (uppercase and lowercase)
//     const sanitizedValue = event.target.value.replace(/[^a-zA-Z\s]/g, "");
//     event.target.value = sanitizedValue;
//   };

//   return (
//     <>
//       <Input
//         {...register(`${name}`, validation)}
//         defaultValue={defaultValue}
//         type={type}
//         placeholder={placeholder}
//         onInput={handleInput} // Restricts input to letters only
//         name={name}
//         value={value}
//         readOnly={readOnly}
//         autoComplete="off"
//         onChange={onChange}
//         className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
//       />
//     </>
//   );
// };

// export default InputName;



import React from "react";
import { Input } from "@windmill/react-ui";

const InputName = ({
  register,
  trigger,
  defaultValue,
  required,
  name,
  label,
  type,
  placeholder,
  pattern,
  minLength,
  maxLength,
  value,
  readOnly,
  disabled,
  onChange,
}) => {
  const validation = {
    required: required === false ? false : `${label} is required!`,
    pattern: {
      value: pattern,
      message: `Invalid ${label}!`,
    },
    maxLength: {
      value: maxLength,
      message: `Maximum Length ${maxLength}!`,
    },
    minLength: {
      value: minLength,
      message: `Minimum Length ${minLength}!`,
    },
    validate: (value) => {
      if (
        typeof value === "string" &&
        value.trim() === "" &&
        required !== false
      ) {
        return `${label} is required!`;
      }

      return true;
    },
  };

  const handleInput = (event) => {
    const sanitizedValue = event.target.value.replace(/[^a-zA-Z\s]/g, "");
    event.target.value = sanitizedValue;
  };

  return (
    <Input
      {...register(`${name}`, validation)}
      defaultValue={defaultValue}
      type={type}
      placeholder={placeholder}
      onInput={handleInput}
      name={name}
      value={value}
      readOnly={readOnly}
      disabled={disabled}
      autoComplete="off"
      onChange={onChange}
      className="border h-10 text-sm focus:outline-none block w-full bg-white-100 dark:bg-white border-transparent focus:bg-white"
    />
  );
};

export default InputName;
